const getters = {
  cur_module_id: state => state.device_lib.cur_module_id,
  cur_device_id: state => state.device_lib.cur_device_id,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js